import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { TextField, SegmentedField, SelectField } from '../shared/FormField';
import { DEPARTMENT_CATEGORY_OPTIONS } from '../../../api/departmentsApi';
import { parseApiError } from '../FoundationalTables/SpeciesLivestockRegistry/registryHelpers';

const blank = { name: '', category: 'department', parentDepartmentId: '' };

export default function CreateDepartmentModal({ isOpen, onClose, onCreate, parentOptions = [] }) {
  const [form, setForm] = useState(blank);
  const [status, setStatus] = useState('idle');
  const [errMsg, setErrMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const set = (key) => (value) => setForm((current) => ({ ...current, [key]: value }));

  const submit = async () => {
    if (submitting) return;

    if (!form.name.trim() || !form.category || (form.category === 'unit' && !form.parentDepartmentId)) {
      setErrMsg('Please complete the required fields before saving.');
      setStatus('error');
      return;
    }

    setSubmitting(true);
    setStatus('idle');
    setErrMsg('');

    try {
      await onCreate({
        name: form.name.trim(),
        category: form.category,
        parentDepartmentId: form.category === 'unit' ? form.parentDepartmentId : null,
      });
      setStatus('success');
    } catch (error) {
      setErrMsg(parseApiError(error, 'Unable to create record.'));
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setForm(blank);
    setStatus('idle');
    setErrMsg('');
    setSubmitting(false);
    onClose();
  };

  return (
    <Modal
      title="Create Department / Unit"
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submit}
      status={status}
      errorMessage={errMsg}
      onContinue={handleClose}
      submitLabel="Create"
      successTitle="Record Created"
      successMessage="The department/unit record was saved."
      isSubmitting={submitting}
    >
      <SegmentedField
        label="Category"
        required
        value={form.category}
        onChange={(value) => setForm((current) => ({ ...current, category: value, parentDepartmentId: value === 'unit' ? current.parentDepartmentId : '' }))}
        options={DEPARTMENT_CATEGORY_OPTIONS}
      />
      <TextField
        label="Name"
        required
        value={form.name}
        onChange={set('name')}
        placeholder="e.g. Dairy Production"
      />
      {form.category === 'unit' && (
        <SelectField
          label="Parent Department"
          required
          value={form.parentDepartmentId}
          onChange={set('parentDepartmentId')}
          options={parentOptions}
          placeholder="Select parent department"
        />
      )}
    </Modal>
  );
}
